(() => {
    if (window.HdProductTabsInitialized) return;
    window.HdProductTabsInitialized = true;

    const offsetTop = 160;

    const smoothScrollToTab = (content) => {
        const labelId = content.id.replace("tab-content-", "tab-label-");
        const label = document.getElementById(labelId);
        const target = label || content;

        window.scroll({
            top: target.getBoundingClientRect().top + window.scrollY - offsetTop,
            behavior: "smooth",
        });
    };

    const refreshVisibleCards = (content) => {
        if (!content) return;

        requestAnimationFrame(() => requestAnimationFrame(() => {
            const cards = Array.from(content.querySelectorAll("squama-item"));
            cards.forEach((card) => {
                card.uninit?.();
                card.style.height = "auto";
            });

            const height = Math.max(0, ...cards.map((card) => card.scrollHeight));

            if (height > 0) {
                cards.forEach((card) => {
                    card.style.height = `${Math.ceil(height)}px`;
                    card.setAttribute("data-status", "ready");
                });
            }
        }));
    };

    const syncAccordionState = (productTabs) => {
        productTabs.querySelectorAll('.collapsed-inner > input[id^="tab-"]').forEach((input) => {
            const label = document.getElementById(`${input.id}-label`) || document.querySelector(`label[for="${input.id}"]`);
            label?.setAttribute("aria-expanded", input.checked ? "true" : "false");
        });
    };

    const initProductTabs = (productTabs) => {
        if (!productTabs || productTabs.dataset.hdTabsInitialized === "true") return;
        productTabs.dataset.hdTabsInitialized = "true";
        const controller = new AbortController();
        productTabs.hdTabsController = controller;
        const options = { signal: controller.signal };

        productTabs.addEventListener("keydown", (event) => {
            const label = event.target.closest('.collapsed-inner label[role="button"]');
            if (!label || (event.key !== "Enter" && event.key !== " ")) return;
            event.preventDefault();
            label.click();
        }, options);

        productTabs.addEventListener("click", (event) => {
            const label = event.target.closest('.collapsed-inner label[role="button"]');
            if (!label) return;
            const input = document.getElementById(label.getAttribute("for"));
            if (!input?.checked) return;
            event.preventDefault();
            input.checked = false;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        }, options);

        productTabs.addEventListener("change", (event) => {
            const radio = event.target;
            if (radio.id?.indexOf("tab-") !== 0) return;

            if (radio.checked) {
                productTabs.querySelectorAll('.collapsed-inner > input[id^="tab-"]').forEach((input) => {
                    if (input !== radio) input.checked = false;
                });
            }
            syncAccordionState(productTabs);

            const content = document.getElementById(radio.id.replace("tab-", "tab-content-"));
            if (!radio.checked || !content) return;
            refreshVisibleCards(content);

            window.setTimeout(() => {
                if (content.getBoundingClientRect().y < offsetTop) smoothScrollToTab(content);
            }, 100);
        }, options);

        syncAccordionState(productTabs);
        const checked = productTabs.querySelector('input[id^="tab-"]:checked');
        if (checked) refreshVisibleCards(document.getElementById(checked.id.replace("tab-", "tab-content-")));
    };

    const initReviewLinks = () => {
        document.querySelectorAll('[href="#judgeme-product-reviews"]:not([data-hd-review-link])').forEach((link) => {
            link.dataset.hdReviewLink = "true";
            link.addEventListener("click", (event) => {
                const review = document.getElementById("judgeme-product-reviews");
                const content = review?.parentElement;
                if (!content) return;

                event.preventDefault();
                smoothScrollToTab(content);
                const radio = document.getElementById(content.id.replace("tab-content-", "tab-"));
                if (radio) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event("change", { bubbles: true }));
                }
            });
        });
    };

    const initAll = (root = document) => {
        root.querySelectorAll?.(".product-tabs").forEach(initProductTabs);
        initReviewLinks();
    };

    initAll();
    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
    document.addEventListener("shopify:section:unload", (event) => {
        event.target.querySelectorAll?.(".product-tabs").forEach((tabs) => {
            tabs.hdTabsController?.abort();
            delete tabs.dataset.hdTabsInitialized;
        });
    });
})();
